import { styled } from '@stitches/react'

// TODO: Delete and replace in favor of modular text or header component
export const Subtitle = styled('h5', {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 500,
  marginBottom: '16px'
})
